import router from '@/router';
import { now } from '@/helpers/date';
import { NOTIFICATION_URL } from '@/modules/notification/notification.contants';
import * as notificationResource from '@/modules/notification/notification.resource';

export function fetchNotifications(pagination) {
  return new Promise((resolve, reject) =>
    notificationResource
      .fetchNotifications(pagination)
      .then(({ data }) => {
        resolve({
          data: data.notifications.data,
          unreaded: data.unreaded,
          pagination: {
            page: data.notifications.page,
            total: parseInt(data.notifications.total),
          },
        });
      }).catch(err => reject(err)));
}

export function markNotificationAsRead(notification) {
  return notificationResource.markNotificationAsRead(notification.id, now());
}

export function markAllNotificationsAsReaded() {
  return notificationResource.markAllNotificationsAsReaded(now());
}

export function goToListNotifications() {
  router.push({ name: NOTIFICATION_URL.name });
}
